import React from 'react'
import {useI18n} from 'i18n/I18nContext'
import {getOrgFaqEntry} from './orgFaqData'
import type {OrgFaqKey} from './orgFaqKeys'

export function OrgFaqHelp(props: {faqKey: OrgFaqKey}) {
  const {locale} = useI18n()
  const {a} = getOrgFaqEntry(locale, props.faqKey)
  return (
    <div
      style={{
        whiteSpace: 'pre-line',
        maxWidth: 420,
        fontSize: 14,
        lineHeight: 1.5,
      }}
    >
      {a}
    </div>
  )
}
